module.exports = __webpack_public_path__ + "b4c238c685672679a418e9760c79f6e2.pdf";